import { useState, useEffect } from "react";
import Login from "../Components/Login2";
import Footer from "../Components/footer";
import { verifyLogin } from "./api";
import { Navigate, useLocation, Link } from "react-router-dom";
import Header from "../Components/header";
import { GoogleLogin } from "@react-oauth/google";

const LoginPage = () => {
  const [loggedIn, setUserLogged] = useState(null);
  const location = useLocation();
  const { state } = location;
  const from = state?.from || "/profilo";

  const expired = location.state || null;
  useEffect(() => {
    const checkUser = async () => {
      const loggedIn = await verifyLogin();
      setUserLogged(loggedIn);
    };

    checkUser();
  }, []);

  const handleLoginSuccess = (response) => {
    console.log("Login Success:", response);
    // Puoi decodificare il token JWT o inviarlo al server per la gestione
  };

  const handleLoginError = () => {
    console.log("Login Failed");
  };

  if (loggedIn) {
    return <Navigate to={from} />;
  }

  console.log("EXPIRED: ", expired);
  return (
    <div>
      <Header />
      <div>
        <Login></Login>
        <Footer />
      </div>
    </div>
  );
};

export default LoginPage;

/*      {expired && (
        <div className="bg-red-200 w-3/4">
          Accesso scaduto
          <br />
          Effettua nuovamente il{" "}
          <Link to="/login" className="text-blue-400 hover:underline">
            login
          </Link>
        </div>
      )}*/
